module.exports = __webpack_public_path__ + "static/media/waves.3031b461.svg";